module.exports = __webpack_public_path__ + "img/form-a11y-8.4b48ba41.png";